import React from "react";

/**
 * Error Boundary - يمنع كراش مكون واحد من تعطيل التطبيق كاملاً
 * بدلاً من شاشة سوداء، يعرض رسالة خطأ واضحة مع زر إعادة تحميل
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    // Log to console for debugging
    console.error("[ErrorBoundary] Caught error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoLogin = () => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    } catch (e) {}
    window.location.href = "/login";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          dir="rtl"
          className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950"
        >
          <div className="max-w-md w-full bg-slate-900/90 backdrop-blur-xl border border-red-500/20 rounded-2xl p-6 shadow-2xl">
            <div className="flex flex-col items-center text-center gap-4">
              <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-8 h-8 text-red-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.008v.008H12v-.008z"
                  />
                </svg>
              </div>
              <div>
                <h1 className="text-xl font-bold text-white mb-2">
                  حصل خطأ غير متوقع
                </h1>
                <p className="text-sm text-slate-400 leading-relaxed">
                  يرجى إعادة تحميل الصفحة. إذا استمرت المشكلة، سجل خروج وادخل من جديد.
                </p>
              </div>

              {this.state.error && (
                <details className="w-full text-right">
                  <summary className="text-xs text-slate-500 cursor-pointer hover:text-slate-300">
                    التفاصيل التقنية
                  </summary>
                  <pre className="mt-2 p-3 bg-slate-950/80 rounded-lg text-[10px] text-red-300 overflow-auto max-h-40 text-left" dir="ltr">
                    {String(this.state.error?.message || this.state.error)}
                    {this.state.errorInfo?.componentStack
                      ? "\n" + this.state.errorInfo.componentStack.split("\n").slice(0, 6).join("\n")
                      : ""}
                  </pre>
                </details>
              )}

              <div className="flex gap-2 w-full mt-2">
                <button
                  onClick={this.handleReload}
                  className="flex-1 py-3 rounded-xl bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white font-bold transition-all"
                  data-testid="error-boundary-reload-btn"
                >
                  إعادة تحميل
                </button>
                <button
                  onClick={this.handleGoLogin}
                  className="flex-1 py-3 rounded-xl bg-slate-800 hover:bg-slate-700 border border-slate-700 text-white font-bold transition-all"
                  data-testid="error-boundary-login-btn"
                >
                  تسجيل دخول جديد
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
